export const formatText = (text) => {
  const spaceRemoved = text.split('-').join(' ');
  return spaceRemoved.charAt(0).toUpperCase() + spaceRemoved.slice(1);
};
